<template>
  <section class="intro">
    <LineText v-if="data.lineText !== undefined" :title="data.lineText"/>
    <div class="intro__container c-container c-container--small">
      <h2
        class="intro__title"
        data-anim="title"
      >
        {{ data.title }}
      </h2>
      <div class="intro__text">
        <p
          v-for="(paragraph, i) in data.content"
          :key="i"
          data-anim="paragraph"
        >{{ paragraph }}</p>
      </div>
    </div>
  </section>
</template>

<script>
import LineText from '@/components/LineText.vue';

export default {
  name: 'Intro',

  components: {
    LineText,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~sass-mq/mq";

.intro {
  &__container {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-flow: row wrap;
  }

  &__title {
    width: 100%;
    flex: 0 0 100%;
    margin-bottom: 20px;

    @include mq(ipadP) {
      width: calc(40% - 40px);
      flex: 0 0 calc(40% - 40px);
      margin-bottom: 0;
    }
  }

  &__text {
    width: 100%;
    flex: 0 0 100%;

    @include mq(ipadP) {
      width: calc(60% - 40px);
      flex: 0 0 calc(60% - 40px);
    }

    & p {
      display: inline-block;
      margin-bottom: 20px;

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
}
</style>
